var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApp = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 155 155",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "app_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 155,
  height: 155
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h155v155H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#app_svg__a)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.199 145.312c-3.263 0-6.024-1.13-8.285-3.39-2.26-2.261-3.39-5.022-3.39-8.285V21.363c0-3.263 1.13-6.024 3.39-8.285 2.26-2.26 5.022-3.39 8.285-3.39h60.608c3.262 0 6.024 1.13 8.284 3.39 2.261 2.26 3.391 5.022 3.391 8.285v112.274c0 3.263-1.13 6.024-3.391 8.285-2.26 2.26-5.022 3.39-8.284 3.39H47.199Zm-1.988-17.76v6.085c0 .498.207.953.622 1.366.413.415.868.622 1.366.622h60.608c.497 0 .952-.207 1.366-.622.414-.413.621-.868.621-1.366v-6.085H45.211Zm0-9.687h64.583v-80.73H45.211v80.73Zm0-90.417h64.583v-6.085c0-.498-.207-.953-.621-1.366-.414-.415-.869-.622-1.366-.622H47.199c-.498 0-.953.207-1.366.622-.415.413-.622.868-.622 1.366v6.085Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.497 58.125c-14.273 0-25.833 5.938-25.833 13.286 0 4.314 3.978 8.16 10.156 10.594 1.17 5.895-3.838 7.86-3.838 7.86s4.54 2.094 10.53-1.88c1.966-1.28 2.948-2.69 3.416-3.588 1.779.214 3.65.3 5.57.3 14.273 0 25.833-5.939 25.833-13.286 0-7.348-11.56-13.286-25.834-13.286Z"
}))));
export default SvgApp;